<template>
  <div>
    <el-button
      icon="el-icon-plus"
      v-if="!($store.state.userPower==='C')"
      round
      type="primary"
      @click="dialogVisible = true"
    >Assign Homework</el-button>
    <HomeworkCollapseList :homework-list="homeworkList" @refresh-list="refreshList" />

    <HomeworkAssignForm :dialogVisible.sync="dialogVisible" @refresh-list="refreshList" />
  </div>
</template>

<script>
import HomeworkCollapseList from "@/components/HomeworkCollapseList.vue";
import HomeworkAssignForm from "@/components/HomeworkAssignForm.vue";
import { getHomeworkListByClass } from "@/api";
import moment from "moment";

export default {
  name: "HomeworkList",
  components: {
    HomeworkCollapseList,
    HomeworkAssignForm
  },
  data() {
    return {
      homeworkList: [],
      dialogVisible: false
    };
  },
  mounted() {
    this.getHomeworkList();
  },
  methods: {
    refreshList() {
      this.getHomeworkList();
    },
    getHomeworkList() {
      getHomeworkListByClass(this.$route.params.class_id).then(res => {
        this.homeworkList = res.map((item, index) => ({
          index,
          ...item,
          deadline: moment(item.deadline).format("MMM Do, YYYY, HH:mm")
        }));
      });
    }
  }
};
</script>

<style>
</style>